import React from "react";
import { Route } from "react-router";
import { RedirectKeepingQuery } from "./RedirectKeepingQuery";
import type { RouteDef } from "./RouteDef";
import type { RoutePathMap } from "./useRoutePaths";

export function renderRouteAliases<T extends Record<string, RouteDef>>(
  routes: T,
  currentPaths: RoutePathMap<T>,
): React.ReactElement[] {
  const result: React.ReactElement[] = [];
  for (const key in routes) {
    const def = routes[key];
    const currentPath = currentPaths[key];

    for (const path of Object.values(def.paths)) {
      if (path && path !== currentPath) {
        result.push(
          <Route
            key={`${String(key)}-lang-${path}`}
            path={path}
            element={<RedirectKeepingQuery to={currentPath} />}
          />,
        );
      }
    }

    for (const alias of def.aliases ?? []) {
      if (alias === currentPath) continue;
      result.push(
        <Route
          key={`${String(key)}-alias-${alias}`}
          path={alias}
          element={<RedirectKeepingQuery to={currentPath} />}
        />,
      );
    }
  }
  return result;
}
